import {config as dateColumnConfig} from '../../common/DateColumn';

export const prop = 'eD';

export const config = (labels) => dateColumnConfig({id: 'end', label: labels.end, prop});
